module.exports = __webpack_public_path__ + "static/media/success_2.25d60757.gif";